import * as React from "react";
import StoresTable from "../tables/StoresTable";
import StoreFilter from '../filters/StoreFilter';
import { Stack } from "@mui/material";

function Stores({legalEntity, dealer}: {legalEntity: string, dealer: string}) {

    return (
        <Stack direction={'column'} spacing={2} margin={'16px'}>
            <StoreFilter/>
            <StoresTable legalEntity={legalEntity} dealer={dealer}/>
        </Stack>
    )
}

export default Stores;